import React from 'react';

import EN from './EN';

/**
 * 自动续费协议组件
 * 暂时中英文都使用英文版本
 */
export const SmartAutoRenewalAgreement: React.FC = () => {
  return <EN />;
};

export default SmartAutoRenewalAgreement;
